<template>
  <div
    class="d-flex-row space-between"
    v-for="packSelectedOption in selectedOptions"
    :key="packSelectedOption"
  >
    <div class="d-flex-row justify-start flex-8">
      <img
        :src="packSelectedOption.icon"
        alt="Game pack selected option icon"
        height="20"
        width="20"
        @error="hideImage"
      />
      <p class="t-grey font-family-2 regular-l">
        {{ packSelectedOption.title }}
      </p>
    </div>
    <p class="t-white font-family-2 bold-l">
      {{ renderPrice(packSelectedOption) }}
    </p>
  </div>
</template>

<script>
import { calculateCurrency } from "~/calculate/calculatePrice";
export default {
  data() {
    return {};
  },
  computed: {
    selectedOptions() {
      const gameBadges = this.getGamePack.prices || [];
      const badges = this.checkoutStore.getSelectedBadges || [];
      const packSelectedOptions = gameBadges.filter((badge) =>
        badges.includes(badge.slab)
      );
      return packSelectedOptions;
    },
  },

  methods: {
    renderPrice(option) {
      return `${this.getUserCurrencyCode}${parseFloat(
        calculateCurrency(option.price)
      ).toFixed(2)}`;
    },
    hideImage(event) {
      event.target.style.display = "none";
    },
  },

  setup() {
    const { getGame, getGamePack } = useGameStore();
    const checkoutStore = useCheckoutStore();
    const { getUserCurrencyCode } = useUserStore();

    const { currentGamePackSlug } = useGameComposable();
    return {
      getGame,
      getGamePack,
      checkoutStore,
      getUserCurrencyCode,
      currentGamePackSlug,
    };
  },
};
</script>
